import React from "react";

const STATUS_STYLES = {
  New: { background: "#dbeafe", color: "#1d4ed8", border: "1px solid #bfdbfe" },
  "In Progress": { background: "#fef9c3", color: "#854d0e", border: "1px solid #fde68a" },
  Closed: { background: "#dcfce7", color: "#166534", border: "1px solid #bbf7d0" },
};

const PRIORITY_STYLES = {
  High: { background: "#fee2e2", color: "#991b1b", border: "1px solid #fecaca" },
  Medium: { background: "#fff7ed", color: "#9a3412", border: "1px solid #fed7aa" },
  Low: { background: "#f0fdf4", color: "#166534", border: "1px solid #bbf7d0" },
};

const TYPE_STYLES = {
  "Enhancement-Client": { background: "#ede9fe", color: "#5b21b6", border: "1px solid #ddd6fe" },
  "Data Export": { background: "#e0f2fe", color: "#0369a1", border: "1px solid #bae6fd" },
  "Defect-Internal": { background: "#fce7f3", color: "#9d174d", border: "1px solid #fbcfe8" },
};

const TicketStatusBadge = ({ type, value }) => {
  let style = {};
  if (type === "status") style = STATUS_STYLES[value] || { background: "#f3f4f6", color: "#374151", border: "1px solid #e5e7eb" };
  if (type === "priority") style = PRIORITY_STYLES[value] || { background: "#f3f4f6", color: "#374151", border: "1px solid #e5e7eb" };
  if (type === "ticketType") style = TYPE_STYLES[value] || { background: "#f3f4f6", color: "#374151", border: "1px solid #e5e7eb" };

  return (
    <span style={{
      ...style,
      display: "inline-block",
      fontSize: 11,
      fontWeight: 600,
      padding: "2px 9px",
      borderRadius: 20,
      whiteSpace: "nowrap",
    }}>
      {value}
    </span>
  );
};

export default TicketStatusBadge;